import { registrationResource } from './resource'

export const registrationService = {
  register: (signal) => (data) => registrationResource.post('/known', data, { signal: signal() }),
  connect: (signal) => (data) =>  registrationResource.post('/possible', data, { signal: signal() }),
  create: (signal) => (data) =>  registrationResource.post('/new', data, { signal: signal() }),
  verify: (signal) => (data) => registrationResource.post('/verify', data, { signal: signal() })
}
